export default __webpack_public_path__ + "static/harri-headshot-828bcf6a492c6059a6326eed31e4bf07.jpg";